import {
  createCanvas,
  loadImage,
  detectOrientation,
  calculateMargins,
  drawImageWithinMargins,
  applyFilter,
  addLogo,
  updateAcceptedPhotos,
} from "./utils";

const processSinglePhoto = async (
  photoId,
  allFrames,
  allPhotos,
  originalImages,
  originalImagesLogo,
  setOriginalImagesLogo,
  setAcceptedPhotos,
  frameId,
  logoImage
) => {
  const photo = allPhotos.find((p) => p.id === photoId);
  if (!photo || !photo.url) return null;
  const originalImage = await loadImage(originalImages[photoId]);

  const canvas = createCanvas(originalImage.width, originalImage.height);
  const ctx = canvas.getContext("2d");
  const orientation = detectOrientation(
    originalImage.width,
    originalImage.height
  );
  const frame = allFrames.find((f) => f.id === frameId);
  const margins = calculateMargins(originalImage, frame, orientation);

  drawImageWithinMargins(ctx, originalImage, margins);

  const filterSrc = frame.filters[orientation].image;
  await applyFilter(ctx, filterSrc);

  if (photo.logoAdded) {
    const filterOnlyImageSrc = canvas.toDataURL("image/png");
    originalImagesLogo[photoId] = filterOnlyImageSrc;
    setOriginalImagesLogo((prev) => ({
      ...prev,
      [photoId]: filterOnlyImageSrc,
    }));

    const logoPositionData = await addLogo(
      ctx,
      photo.logoSize,
      photo.logoPosition,
      Math.min(originalImage.width, originalImage.height),
      logoImage
    );

    updateAcceptedPhotos(
      setAcceptedPhotos,
      photoId,
      margins,
      logoPositionData,
      frame.filters[orientation].id
    );
  } else {

    await updateAcceptedPhotos(
      setAcceptedPhotos,
      photoId,
      margins,
      null,
      frame.filters[orientation].id
    );
  }
  
  return { photoId, newImageSrc: canvas.toDataURL("image/jpeg") };
};

const applyFilterToImages = async (
  frameId,
  allFrames,
  allPhotos,
  setAllPhotos,
  selectedPhotos,
  originalImages,
  originalImagesLogo,
  setOriginalImagesLogo,
  setLoadingPhotoIds,
  setAcceptedPhotos,
  logoImage
) => {
  setLoadingPhotoIds(selectedPhotos);
  for (const photoId of selectedPhotos) {
    try {
      const result = await processSinglePhoto(
        photoId,
        allFrames,
        allPhotos,
        originalImages,
        originalImagesLogo,
        setOriginalImagesLogo,
        setAcceptedPhotos,
        frameId,
        logoImage
      );

      if (result) {
        const { newImageSrc } = result;
        setAllPhotos((prevPhotos) =>
          prevPhotos.map((p) =>
            p.id === photoId ? { ...p, url: { ...p.url, url: newImageSrc } } : p
          )
        );
      }
    } catch (error) {
      console.error("Error applying filter:", error);
    }
    setLoadingPhotoIds((prev) => prev.filter((id) => id !== photoId));
  }
};

export default applyFilterToImages;
